import { generateRequest } from './index';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  Favorites: {
    FetchFavoriteListsPending: 'FetchFavoriteLists_PENDING',
    FetchFavoriteListsCompleted: 'FetchFavoriteLists_FULFILLED',
    FetchFavoriteListsFailed: 'FetchFavoriteLists_FAILED',
    CreateFavoriteListPending: 'CreateFavoriteList_PENDING',
    CreateFavoriteListCompleted: 'CreateFavoriteList_FULFILLED',
    CreateFavoriteListFailed: 'CreateFavoriteList_FAILED',
    UpdateFavoriteListPending: 'UpdateFavoriteList_PENDING',
    UpdateFavoriteListCompleted: 'UpdateFavoriteList_FULFILLED',
    UpdateFavoriteListFailed: 'UpdateFavoriteList_FAILED',
    DeleteFavoriteListPending: 'DeleteFavoriteList_PENDING',
    DeleteFavoriteListCompleted: 'DeleteFavoriteList_FULFILLED',
    DeleteFavoriteListFailed: 'DeleteFavoriteList_FAILED',
    FetchFavoriteStationsPending: 'FetchFavoriteStations_PENDING',
    FetchFavoriteStationsCompleted: 'FetchFavoriteStations_FULFILLED',
    FetchFavoriteStationsFailed: 'FetchFavoriteStations_FAILED',
    AddStationToFavoritesPending: 'AddStationToFavorites_PENDING',
    AddStationToFavoritesCompleted: 'AddStationToFavorites_FULFILLED',
    AddStationToFavoritesFailed: 'AddStationToFavorites_FAILED',
    DeleteStationFromFavoritesPending: 'DeleteStationFromFavorites_PENDING',
    DeleteStationFromFavoritesCompleted: 'DeleteStationFromFavorites_FULFILLED',
    DeleteStationFromFavoritesFailed: 'DeleteStationFromFavorites_FAILED',
  },
  MemberInfo: {
    FavoriteStationsCountPending: 'FavoriteStationsCount_PENDING',
    FavoriteStationsCountCompleted: 'FavoriteStationsCount_FULFILLED',
    FavoriteStationsCountFailed: 'FavoriteStationsCount_FAILED',
  },
};

export const getFavoriteLists = () => generateRequest({
  endpoint: '/assets-v2/api/favorites/lists',
  types: [
    Action.Favorites.FetchFavoriteListsPending,
    Action.Favorites.FetchFavoriteListsCompleted,
    Action.Favorites.FetchFavoriteListsFailed,
  ],
});

export const createFavoriteList = newList => generateRequest({
  endpoint: '/assets-v2/api/favorites/lists',
  method: 'POST',
  credentials: 'same-origin',
  body: newList,
  types: [
    Action.Favorites.CreateFavoriteListPending,
    Action.Favorites.CreateFavoriteListCompleted,
    Action.Favorites.CreateFavoriteListFailed,
  ],
});

export const updateFavoriteList = (listId, updatedList) => generateRequest({
  endpoint: `/assets-v2/api/favorites/lists/${listId}`,
  method: 'PUT',
  credentials: 'same-origin',
  body: updatedList,
  types: [
    Action.Favorites.UpdateFavoriteListPending,
    {
      type: Action.Favorites.UpdateFavoriteListCompleted,
      meta: { listId, isUpdatingDefaultList: !!updatedList.is_default },
    },
    Action.Favorites.UpdateFavoriteListFailed,
  ],
});

export const deleteFavoriteList = listId => generateRequest({
  endpoint: `/assets-v2/api/favorites/lists/${listId}`,
  method: 'DELETE',
  credentials: 'same-origin',
  types: [
    Action.Favorites.DeleteFavoriteListPending,
    {
      type: Action.Favorites.DeleteFavoriteListCompleted,
      meta: { listId },
    },
    Action.Favorites.DeleteFavoriteListFailed,
  ],
});

export const fetchFavoriteStations = (listId, stationIds) => generateRequest({
  endpoint: stationIds && stationIds.length
    ? `/assets-v2/api/favorites/lists/${listId}/stations?${toQueryString({ stationIds })}`
    : `/assets-v2/api/favorites/lists/${listId}/stations`,
  types: [
    Action.Favorites.FetchFavoriteStationsPending,
    {
      type: Action.Favorites.FetchFavoriteStationsCompleted,
      meta: { listId },
    },
    Action.Favorites.FetchFavoriteStationsFailed,
  ],
});

export const addStationToFavorites = (listId, stationId) => generateRequest({
  endpoint: `/assets-v2/api/favorites/lists/${listId}/stations`,
  method: 'POST',
  body: {
    stationIds: [stationId],
  },
  credentials: 'same-origin',
  types: [
    Action.Favorites.AddStationToFavoritesPending,
    {
      type: Action.Favorites.AddStationToFavoritesCompleted,
      meta: { listId, stationId },
    },
    Action.Favorites.AddStationToFavoritesFailed,
  ],
});

export const deleteStationFromFavorites = (listId, stationId) => generateRequest({
  endpoint: `/assets-v2/api/favorites/lists/${listId}/stations/${stationId}`,
  method: 'DELETE',
  credentials: 'same-origin',
  types: [
    Action.Favorites.DeleteStationFromFavoritesPending,
    {
      type: Action.Favorites.DeleteStationFromFavoritesCompleted,
      meta: { listId, stationId },
    },
    Action.Favorites.DeleteStationFromFavoritesFailed,
  ],
});

export const countFavoriteStations = () => generateRequest({
  endpoint: '/assets-v2/api/favorites/count',
  types: [
    Action.MemberInfo.FavoriteStationsCountPending,
    Action.MemberInfo.FavoriteStationsCountCompleted,
    Action.MemberInfo.FavoriteStationsCountFailed,
  ],
});
